import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_CLIENT_REPORT_TEMPLATE_NAME = gql`
  query fetchClientReportTemplateName($id: ObjectID!) {
    fetchClientReportTemplate(clientReportTemplateId: $id) {
      clientReportTemplate {
        translatedName { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;
